import React from "react";
import {Formik, Form, Field, ErrorMessage} from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import useLockBodyScroll from "../../hooks/useLockBodyScroll";
import addToMailchimp from 'gatsby-plugin-mailchimp';

const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("* First name is Required."),
    lastName: Yup.string().required("* First name is Required."),
    email: Yup.string()
        .email("* Enter a Valid Email.")
        .required("* Email is Required."),
});

const encode = data => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
};

function SubForm({submitMsg, submitMsgHandler}) {
    useLockBodyScroll();

    if (submitMsg) return <p className="submit-message h3">{submitMsg}</p>;
    return (
        <>
            <Formik
                initialValues={{
                    firstName: "",
                    lastName: "",
                    email: "",
                }}
                validationSchema={validationSchema}
                onSubmit={(values, {setSubmitting}) => {
                    fetch("/", {
                        method: "POST",
                        headers: {"Content-Type": "application/x-www-form-urlencoded"},
                        body: encode({
                            "form-name": "sub-form",
                            ...values,
                        }),
                    })
                        .then(() => {
                            submitMsgHandler("Sent.");
                            addToMailchimp(values.email)
                            setSubmitting(false);
                        })
                        .catch(error => {
                            submitMsgHandler("Something went wrong! Please email us directly.");
                            setSubmitting(false);
                        });
                }}
            >
                {({isSubmitting}) => (
                    <Form
                        className="form"
                        method="post"
                        name="sub-form"
                        data-netlify="true"
                        data-netlify-honeypot="bot-field"
                    >
                        <div className="two-col-fields">
                            <div className="fieldset">
                                <label htmlFor="firstName" className="label">
                                    Name
                                </label>
                                <Field
                                    className="input"
                                    type="text"
                                    name="firstName"
                                    placeholder="First name"
                                />
                                <ErrorMessage
                                    className="errorMsg"
                                    name="name"
                                    component="small"
                                />
                            </div>
                            <div className="fieldset">
                                <label htmlFor="lastName" className="label">
                                    Name
                                </label>
                                <Field
                                    className="input"
                                    type="text"
                                    name="lastName"
                                    placeholder="Last name"
                                />
                                <ErrorMessage
                                    className="errorMsg"
                                    name="name"
                                    component="small"
                                />
                            </div>
                        </div>

                        <div className="fieldset">
                            <label htmlFor="email" className="label">
                                Email
                            </label>
                            <Field
                                className="input"
                                type="text"
                                name="email"
                                placeholder="Email"
                            />
                            <ErrorMessage
                                className="errorMsg"
                                name="email"
                                component="small"
                            />
                        </div>
                        <div>
                            <input
                                name="submit"
                                type="submit"
                                disabled={isSubmitting}
                                value="Submit"
                                className="button large"
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
}

SubForm.propTypes = {
    submitMsg: PropTypes.bool.isRequired,
    submitMsgHandler: PropTypes.func.isRequired,
};

export default SubForm;
